import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { SettingsProvider } from './context/SettingsContext';
import { AuthProvider } from './context/AuthContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import StickyBookButton from './components/layout/StickyBookButton';
import Home from './pages/Home';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import Book from './pages/Book';
import About from './pages/About';
import Contact from './pages/Contact';

// Admin
import AdminLayout from './components/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Appointments from './pages/admin/Appointments';
import ServicesAdmin from './pages/admin/ServicesAdmin';
import Messages from './pages/admin/Messages';
import Settings from './pages/admin/Settings';
import Availability from './pages/admin/Availability';
import Login from './pages/admin/Login';

import './App.css';

// Public layout wrapper
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <div className="flex-1">{children}</div>
    <Footer />
    <StickyBookButton />
  </>
);

function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App min-h-screen flex flex-col">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
              <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
              <Route path="/book" element={<PublicLayout><Book /></PublicLayout>} />
              <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
              <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
              
              {/* Admin Login (unprotected) */}
              <Route path="/admin/login" element={<Login />} />
              
              {/* Admin Routes (protected) */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="appointments" element={<Appointments />} />
                <Route path="services" element={<ServicesAdmin />} />
                <Route path="availability" element={<Availability />} />
                <Route path="messages" element={<Messages />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Routes>
            
            <Toaster 
              position="top-center"
              toastOptions={{
                style: {
                  background: 'white',
                  border: '1px solid var(--border-light)',
                  color: 'var(--text-primary)',
                  borderRadius: '12px'
                }
              }}
            />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
